// String values, not numeric — the backend's EnumJsonConverter serializes/deserializes enums by name
// (no [Description] attribute means it falls back to value.ToString()), e.g. "Tier0", "PendingReview".
export enum PermissionTier {
    Unreviewed = 'Unreviewed',
    Tier0 = 'Tier0',
    Tier1 = 'Tier1',
    Tier2 = 'Tier2',
    Tier3 = 'Tier3'
}

export enum PermissionTierReviewStatus {
    NotApplicable = 'NotApplicable',
    PendingReview = 'PendingReview',
    Reviewed = 'Reviewed'
}

export const PermissionTierLabels: Record<PermissionTier, string> = {
    [PermissionTier.Unreviewed]: 'Unreviewed',
    [PermissionTier.Tier0]: 'Tier 0',
    [PermissionTier.Tier1]: 'Tier 1',
    [PermissionTier.Tier2]: 'Tier 2',
    [PermissionTier.Tier3]: 'Tier 3'
};

export interface IGraphPermissionTierReview {
    permissionId: string;
    name: string;
    description: string;
    tier: PermissionTier;
    tierReviewStatus: PermissionTierReviewStatus;
    tierSource: string;
    approvers: string[];
    reviewer: string;
}

export interface ISubmitGraphPermissionTierReviewBulkRequest {
    permissionIds: string[];
    tier: PermissionTier;
    approvers: string[];
}
